// extracted by mini-css-extract-plugin
export default {"logo":"TeamLogo_logo__h+rrb"};